import 'react';
import { getScaledImageSource } from '@atc/images';
import { Image, Label, SubHeading, Button } from 'reaxl';
import clsx from 'clsx';
import { jsxs, jsx } from 'react/jsx-runtime';
function DealBanner(_ref) {
  let {
    imgSrc = '',
    dealerName = 'this dealer',
    viewDealClickHandler = () => {},
    isCompact,
    uiContext = 'default',
    onContactOwnerClick = () => {},
    dealVehicle = {},
    ...rest
  } = _ref;
  const isEsntial = uiContext === 'esntial';
  const isEsntialComplete = uiContext === 'esntialComplete';
  const bannerTitle = {
    default: 'Your offer has been created!',
    esntial: 'Did you stall out?',
    esntialComplete: 'Your order is confirmed!'
  };
  const bannerText = {
    default: `Someone from ${dealerName} will review your offer and respond to you shortly.`,
    esntial: 'Pick up where you left off in this order if you still want to get behind the wheel of this car!',
    esntialComplete: `Congratulations! You're the new driver of a ${dealVehicle?.year} ${dealVehicle?.make} ${dealVehicle?.model}!`
  };
  const imageSrc = getScaledImageSource({
    src: imgSrc,
    height: 100,
    width: 135
  });
  const handleButtonClick = event => {
    if (isEsntial || isEsntialComplete) {
      onContactOwnerClick('emailForm');
    } else {
      viewDealClickHandler(event);
    }
  };
  return /*#__PURE__*/jsxs("div", {
    "data-cmp": "deal-banner",
    className: "clearfix",
    ...rest,
    children: [/*#__PURE__*/jsx("div", {
      className: "pull-left margin-right-5",
      children: /*#__PURE__*/jsx(Image, {
        src: imageSrc,
        lazyload: true,
        alt: "",
        height: 100,
        width: 135,
        className: "img-responsive"
      })
    }), !isEsntialComplete && /*#__PURE__*/jsx(Label, {
      bsStyle: "success",
      children: "In Progress"
    }), /*#__PURE__*/jsx(SubHeading, {
      className: "margin-vertical-2",
      size: 500,
      color: "primary",
      children: bannerTitle[uiContext]
    }), /*#__PURE__*/jsx("p", {
      className: clsx('padding-top-4', 'padding-top-sm-0', 'clear', {
        'clear-sm-none': !isCompact
      }),
      children: bannerText[uiContext]
    }), /*#__PURE__*/jsx(Button, {
      bsStyle: "text",
      onClick: handleButtonClick,
      children: isEsntial || isEsntialComplete ? 'Contact Dealer' : 'View Your Offer Status'
    })]
  });
}
export { DealBanner as default };
